import { useAuth } from '../AuthContext.jsx';

export default function NoAccess() {
  const { session, signOut } = useAuth();
  return (
    <div className="signin">
      <img src="/dl-logo.png" alt="Digital Lotus" className="brand-mark" />
      <h1>Not quite yet</h1>
      <p>
        You signed in as <strong>{session?.user?.email}</strong>, but this
        address isn't on the portal yet.
      </p>
      <p className="hint">
        Ask Digital Lotus to add you, then click your sign-in link again.
      </p>
      <div style={{ height: 12 }} />
      <button className="link-btn" onClick={signOut}>Sign out</button>
    </div>
  );
}
